/** Промежуточные результаты wizard/ИИ — сохраняются в constructor_plans.source_snapshot.workflow_checkpoints */
import type { AuthSession } from '../../../types/plans'

export type PlanWorkflowCheckpoint = {
  step: string
  updated_at?: string
  last_error?: string | null
  proposal?: Record<string, unknown> | null
  proposal_id?: string | null
  preview?: unknown
  input_text?: string | null
  applied_mis_plan_id?: string | null
  ops?: unknown[]
  selected_services?: unknown[]
  [key: string]: unknown
}

export type PlanWorkflowCheckpoints = Record<string, PlanWorkflowCheckpoint>

export const WORKFLOW_CHECKPOINT_KEYS = {
  planDiagnosticsBeta: 'plan_diagnostics_auto_compose',
  voiceFill: 'treatment_voice_fill',
  voiceCorrect: 'treatment_voice_correct',
  autoDistribute: 'plan_stage_auto_distribute',
  gammaPresentation: 'gamma_presentation',
} as const

export async function savePlanWorkflowCheckpoint(
  apiBase: string,
  session: AuthSession,
  planId: number,
  key: string,
  payload: PlanWorkflowCheckpoint,
): Promise<void> {
  const res = await fetch(`${apiBase}/staff/constructor/${planId}/workflow-checkpoint`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${session.accessToken}`,
    },
    body: JSON.stringify({ key, payload: { ...payload, updated_at: new Date().toISOString() } }),
  })
  if (!res.ok) {
    console.warn('workflow checkpoint save failed', key, res.status)
  }
}

export function formatCheckpointSavedAt(checkpoint: PlanWorkflowCheckpoint | null | undefined): string | null {
  if (!checkpoint?.updated_at) return null
  const d = new Date(checkpoint.updated_at)
  return Number.isNaN(d.getTime()) ? null : d.toLocaleString('ru-RU')
}

export async function clearPlanWorkflowCheckpoint(
  apiBase: string,
  session: AuthSession,
  planId: number,
  key: string,
): Promise<void> {
  await savePlanWorkflowCheckpoint(apiBase, session, planId, key, {
    step: 'cleared',
    proposal: null,
    last_error: null,
  })
}
